import { LayoutIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Template = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <LayoutIcon {...rest} size={Sizes[size]} color={fill} />;
};

Template.displayName = 'Template';
